"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Search = void 0;
const react_1 = __importDefault(require("react"));
const Search = (props) => {
    return (react_1.default.createElement("svg", { width: "18", height: "18", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
        react_1.default.createElement("path", { d: "M3.90625 9.75004H12.2837L8.62375 13.41C8.33125 13.7025 8.33125 14.1825 8.62375 14.475C8.91625 14.7675 9.38875 14.7675 9.68125 14.475L14.6237 9.53254C14.9162 9.24004 14.9162 8.76754 14.6237 8.47504L9.68875 3.52504C9.39625 3.23254 8.92375 3.23254 8.63125 3.52504C8.33875 3.81754 8.33875 4.29004 8.63125 4.58254L12.2837 8.25004H3.90625C3.49375 8.25004 3.15625 8.58754 3.15625 9.00004C3.15625 9.41254 3.49375 9.75004 3.90625 9.75004Z", fill: "#949494" })));
};
exports.Search = Search;
